import Lottie from "lottie-react";
import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import doctor from "../../Assets/animation/hero1Doctor.json";
import Loading from "../../Shared/Loading";

const BENEFITS = [
  { icon: "solar:diploma-verified-bold-duotone", label: "Expert Medical Team", color: "text-indigo-600", bg: "bg-indigo-50", border: "border-indigo-100" },
  { icon: "solar:heart-pulse-bold-duotone", label: "Patient-First Approach", color: "text-rose-600", bg: "bg-rose-50", border: "border-rose-100" },
  { icon: "solar:shield-check-bold-duotone", label: "Secure & Confidential", color: "text-emerald-600", bg: "bg-emerald-50", border: "border-emerald-100" },
  { icon: "solar:map-point-bold-duotone", label: "Nationwide Coverage", color: "text-amber-600", bg: "bg-amber-50", border: "border-amber-100" },
];

const AboutMedmine = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`https://servercareseebd.careseebd.com/api/v1/grow/getGrow`)
      .then((r) => r.json())
      .then((d) => { if (d?.data?.length) setData(d.data[0]); })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Loading />;

  return (
    <section className="section-py bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Full-width banner image */}
        {data?.img && (
          <div className="mb-20 rounded-3xl overflow-hidden shadow-lg relative">
            <img src={data.img} alt="About Medmyne" className="w-full h-72 sm:h-96 object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
          </div>
        )}

        {/* Two-col layout */}
        <div className="flex gap-16 items-center ">

          {/* ── Left: Lottie + benefit cards radiating around it ── */}
          <div className="relative flex flex-col items-center  flex-1">
            {/* Top row cards */}
            <div className="w-full flex justify-between mb-4 gap-3">
              {BENEFITS.slice(0, 2).map((b) => (
                <div
                  key={b.label}
                  className={`flex-1 flex items-center gap-2.5 p-3 rounded-2xl bg-white border ${b.border} shadow-sm hover:shadow-md transition-shadow`}
                >
                  <div className={`w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 ${b.bg} ${b.color}`}>
                    <Icon icon={b.icon} className="w-5 h-5" />
                  </div>
                  <span className="text-xs font-semibold text-gray-700 leading-tight">{b.label}</span>
                </div>
              ))}
            </div>

            {/* Lottie in the middle */}
            <div className="relative w-full flex items-center justify-center">
              <div className="absolute w-[440px] h-[440px] rounded-full bg-indigo-50 blur-3xl opacity-50 pointer-events-none" />
              <div className="relative z-10 w-full max-w-[480px]">
                <Lottie animationData={doctor} />
              </div>
            </div>

            {/* Bottom row cards */}
            <div className="w-full flex justify-between mt-4 gap-3">
              {BENEFITS.slice(2, 4).map((b) => (
                <div
                  key={b.label}
                  className={`flex-1 flex items-center gap-2.5 p-3 rounded-2xl bg-white border ${b.border} shadow-sm hover:shadow-md transition-shadow`}
                >
                  <div className={`w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 ${b.bg} ${b.color}`}>
                    <Icon icon={b.icon} className="w-5 h-5" />
                  </div>
                  <span className="text-xs font-semibold text-gray-700 leading-tight">{b.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* ── Right: text ── */}
          <div className="lg:pt-6 flex-1">
            <span className="inline-flex items-center gap-1.5 bg-indigo-50 text-indigo-600 border border-indigo-100 rounded-full px-4 py-1 text-xs font-semibold uppercase tracking-widest mb-6">
              <Icon icon="solar:info-circle-bold" className="w-3.5 h-3.5" />
              About Us
            </span>

            <h2 className="font-heading text-4xl sm:text-5xl font-extrabold text-gray-900 leading-tight tracking-tight mb-6">
              {data?.title || "Growing Together"}
            </h2>

            <div
              className="prose text-gray-500 leading-relaxed text-base max-w-none"
              dangerouslySetInnerHTML={{ __html: data?.content || "" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMedmine;
